import { initBuilder } from './builder/initBuilder';
import { initMarketing, normalizePathname } from './marketing/site';

function initRoute(): void {
  const pathname = normalizePathname(window.location.pathname);
  if (pathname === '/builder') {
    document.title = 'GSPro Course Builder';
    initBuilder().catch(console.error);
    return;
  }
  initMarketing(pathname);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRoute);
} else {
  initRoute();
}
